import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from './NotFound'
import ManageTravypass from './Travypass/ManageTravypass'
import OrderReport from './Travypass/OrderReport'

const subList = {
  ManageTravypass: <ManageTravypass />,
  OrderReport: <OrderReport />
}

const SubComponent = ({ subname = 'list' }) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const TravypassPage = ({ location, match }) => <SubComponent subname={match.params.sub} location={location} />

export default TravypassPage



// WEBPACK FOOTER //
// ./src/Pages/TravypassPage.js